module.exports = __webpack_public_path__ + "static/media/12_Event Information.0d71714a.jpg";